module.exports = __webpack_public_path__ + "img/book-sparkles.20ab5f3d.svg";